// extracted by mini-css-extract-plugin
export default {"pannel_body":"PannelBody_pannel_body__ut+0y","large":"PannelBody_large__slFkf"};